export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    receiptList: [
      {
        receiptIdx: 1,
        salesIdx: 1,
        receiptDate: "2023-11-21",
        receiptTime: "12:56:24",
        posNo: "0001",
        amount: 18500,
        type: "RCP001",
        receiptNo: "17004620",
        payType: "PAY001",
        desc: "###영수증 내용###11111111111111111111111",
      },
      {
        receiptIdx: 2,
        salesIdx: 2,
        receiptDate: "2023-11-21",
        receiptTime: "16:16:12",
        posNo: "0002",
        amount: 14000,
        type: "RCP001",
        receiptNo: "17004621",
        payType: "PAY002",
        desc: "###영수증 내용###2222222222222222222",
      },
      {
        receiptIdx: 3,
        salesIdx: 3,
        receiptDate: "2023-11-20",
        receiptTime: "11:11:12",
        posNo: "0002",
        amount: 11000,
        type: "RCP001",
        receiptNo: "17004622",
        payType: "PAY002",
        desc: "###영수증 내용##efgwerfgw",
      },
    ],
  },
};
